import { get } from "lodash";
import { createSelector } from "reselect";

const errors = state => get(state, "errors", []);
export const errorsSelector = createSelector(errors, data => data);
export const hasErrorsSelector = createSelector(errors, data => {
  return data.length > 0;
});
